// extracted by mini-css-extract-plugin
module.exports = {"component":"filter-tag-list_component__lsLCk","tag":"filter-tag-list_tag__mXv4j"};